export default {
	"coupon.SimilarCouponsAreMutuallyExclusive": "同類券互斥",
	"coupon.ThereAreNoCoupons": "暫無相關優惠券",
	"coupon.WaiverOfOffer": "放棄優惠",
	"coupon.ReasonsForUnavailability": "無法用原因：",
	"coupon.Selected": "已選",
	"coupon.sheet": "張",
	"coupon.¥reductionIsAvailable": "可減¥",
	"coupon.AreYouSure": "確定"
}